export type BatchStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
export type RecordStatus = 'PENDING' | 'PROCESSING' | 'AUTHORIZED' | 'REJECTED';

export interface NfseBatchRecord {
  id: number;
  document: string;
  documentType: 'CPF' | 'CNPJ';
  value: number;
  customerId: number | null;
  status: RecordStatus;
}

export interface NfseBatch {
  id: number;
  quantity: number;
  totalValue: number;
  referenceDate: string;
  status: BatchStatus;
  records: NfseBatchRecord[];
  createdAt?: string;
}

export interface CsvRow {
  document: string;
  value: string | number;
}

export interface CsvValidationError {
  row: number;
  field: string;
  message: string;
}

export interface CsvValidationResult {
  valid: boolean;
  errors: CsvValidationError[];
  data: CsvRow[];
}

export interface BatchItem {
  document: string;
  value: number;
}

export interface CreateBatchPayload {
  items: BatchItem[];
  referenceDate: string;
}

export interface BatchFormData {
  referenceDate: string;
  nationalTaxCode: string;
  serviceDescription: string;
  serviceNbs: string;
  hasMunicipalBenefit: boolean;
  serviceComplement: string;
}

export const NATIONAL_TAX_CODE_OPTIONS = [
  {
    value: '100201',
    label: '100201 - Serviços auxiliares aos serviços financeiros...',
  },
  {
    value: '010501',
    label: '010501 - Licenciamento de direitos sobre programas...',
  },
  {
    value: '010701',
    label: '010701 - Serviços de projeto e desenvolvimento, ada...',
  },
  {
    value: '010101',
    label: '010101 - Análise e desenvolvimento de sistemas',
  },
  {
    value: '010401',
    label: '010401 - Elaboração de programas de computadores...',
  },
];

export const SERVICE_NBS_OPTIONS = [
  {
    value: '109059000',
    label:
      '1.0905.90.00 - Taxa de intermediação de pedidos realizados por meio da plataforma Yooga',
  },
  {
    value: '111032900',
    label:
      '1.1103.29.00 - Licenciamento de direitos sobre programas de computador (software) e bancos de dados não classificado em subposições anteriores',
  },
  {
    value: '115022000',
    label:
      '1.1502.20.00 - Serviços de projeto e desenvolvimento, adaptação e instalação de aplicativos e programas personalizados (customizados)',
  },
  {
    value: '115029000',
    label:
      '1.1502.90.00 - Serviços de projeto e desenvolvimento de aplicativos e programas em tecnologia da informação (TI) não classificados em subposições anteriores',
  },
];

export const SERVICE_COMPLEMENT_OPTIONS = [
  { value: 'codigo 1', label: 'Pix - código 1' },
  { value: 'codigo 2', label: 'Pix flash - código 2' },
  { value: 'codigo 3', label: 'Wallet/PagarMe - código 3' },
];

export const NBS_CODE_WITH_COMPLEMENT = '100201';

export interface ValidatedItem {
  document: string;
  value: number;
  customerId: number | null;
  customerName: string;
}

export const BATCH_STATUS_LABELS: Record<BatchStatus, string> = {
  PENDING: 'Pendente',
  PROCESSING: 'Processando',
  COMPLETED: 'Concluído',
  FAILED: 'Falhou',
};

export const RECORD_STATUS_LABELS: Record<RecordStatus, string> = {
  PENDING: 'Pendente',
  PROCESSING: 'Processando',
  AUTHORIZED: 'Autorizado',
  REJECTED: 'Rejeitado',
};

export const BATCH_STATUS_COLORS: Record<BatchStatus, string> = {
  PENDING: 'gray',
  PROCESSING: 'blue',
  COMPLETED: 'green',
  FAILED: 'red',
};

export const RECORD_STATUS_COLORS: Record<RecordStatus, string> = {
  PENDING: 'gray',
  PROCESSING: 'blue',
  AUTHORIZED: 'green',
  REJECTED: 'red',
};

export type NfseReportStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'AUTHORIZED'
  | 'REJECTED'
  | 'FAILED'
  | 'CANCELLED';

export const NFSE_REPORT_STATUS_LABELS: Record<NfseReportStatus, string> = {
  PENDING: 'Pendente',
  PROCESSING: 'Processando',
  AUTHORIZED: 'Autorizado',
  REJECTED: 'Rejeitado',
  FAILED: 'Falhou',
  CANCELLED: 'Cancelado',
};

export const NFSE_REPORT_STATUS_COLORS: Record<NfseReportStatus, string> = {
  PENDING: 'gray',
  PROCESSING: 'blue',
  AUTHORIZED: 'green',
  REJECTED: 'red',
  FAILED: 'red',
  CANCELLED: 'orange',
};

export const RETRANSMIT_ALLOWED_STATUS: NfseReportStatus[] = [
  'REJECTED',
  'FAILED',
];
